import React from 'react';
import useValuePerMonthPerYearTotalChart from './hooks/useValuePerMonthPerYearTotalChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const ValuePerMonthPerYearTotal = ({ height = 400 }) => {
    const { series, subtitles } = useValuePerMonthPerYearTotalChart();

    return (
        <SimpleBars
            series={series}
            values={[]}
            subtitles={subtitles}
            isMoney
            title={`Soma do Valor no Ano Selecionado`}
        />
    );
};
